/**
 * avatarSrc — turn a stored avatar URL into a render-safe `<img src>`.
 *
 * `User.updatedAt` ticks every time the row mutates (Prisma `@updatedAt`),
 * so appending it as a query string forces browsers and the CDN in front
 * of R2 to revalidate the resource after a profile edit — otherwise the
 * stale image stays cached and the navbar keeps showing the old picture.
 *
 * `data:` URLs are returned untouched (they aren't cached by URL).
 * Existing query strings (e.g. signed URLs) are preserved.
 */
export function avatarSrc(
  url: string | null | undefined,
  version: string | number | null | undefined,
): string | null {
  if (!url) return null
  if (url.startsWith('data:')) return url
  if (!version) return url
  const sep = url.includes('?') ? '&' : '?'
  const token =
    typeof version === 'string' ? Date.parse(version) || version : version
  return `${url}${sep}v=${encodeURIComponent(String(token))}`
}
